import React, { useEffect, useState } from 'react'

import versionDetails from '../../util/version'

function Version() {
  const [front, setFront] = useState([])
  const [back] = useState([])

  useEffect(async () => {
    const frontVersion = Object.entries(versionDetails).map(([key, value]) => ({ [key]: value }))
    setFront(frontVersion)
    // const response = await request(api.version())
    // setBack(response)
  }, [])

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {front.length > 0 && back.length > 0 && (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '250px' }}>
          <div style={{ border: '1px solid black', marginRight: '25px', padding: '20px' }}>
            <h1 style={{ fontWeight: 'bold', marginBottom: '8px' }}>Front-end</h1>
            <div>
              <h3>
                <span style={{ fontWeight: 'bold' }}>Data:</span> {front[1].date}
              </h3>
              <h3>
                <span style={{ fontWeight: 'bold' }}>Versão:</span> {front[0].number}
              </h3>
              <h3>
                <span style={{ fontWeight: 'bold' }}>Autor:</span> {front[2].author}
              </h3>
            </div>
          </div>
          <div style={{ border: '1px solid black', marginLeft: '25px', padding: '20px' }}>
            <h1 style={{ fontWeight: 'bold', marginBottom: '8px' }}>Back-end</h1>
            <div>
              <h3>
                <span style={{ fontWeight: 'bold' }}>Data:</span> {back[1].date}
              </h3>
              <h3>
                <span style={{ fontWeight: 'bold' }}>Versão:</span> {back[0].number}
              </h3>
              <h3>
                <span style={{ fontWeight: 'bold' }}>Autor:</span>
              </h3>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Version
